import React, {useEffect, useMemo, useState} from 'react';
import styles from "./RankingAdministration.module.scss";
import { DataGrid } from '@mui/x-data-grid';
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import TextInput from "../../Components/TextInput/TextInput";
import Button, {BUTTON_TYPE_SECONDARY} from "../../Components/Button/Button";
import {PROD_API_URL} from "../../constants/constants";
import TabSelector from "../../Components/TabSelector/TabSelector";
import moment from "moment";
import {hasValue} from "../../helpers/helperFunctions";
import toast from "react-hot-toast";
import {errorToast, successToast} from "../../helpers/toastCSS";
import ImageSubmit from "../../Components/ImageSubmit/ImageSubmit";
import ExperienceHistory from "../../Components/ExperienceHistory/ExperienceHistory";

const RankingLeaderboardColums = [
  {field: 'level', headerName: 'Level', width: 100},
  {field: 'username', headerName: 'Name', flex: 1},
  {
    field: 'profileImage',
    headerName: 'Image',
    width: 200,
    renderCell: (params) => (
        params.value ? <img className={styles.rankImage} src={params.value} alt="profileImage"/> : ''
    )
  },
  {field: 'experiencePoints', headerName: 'Experience Gained', width: 200},
  {field: 'solanaWallet', headerName: 'Wallet ', flex: 1},

];

const RankingLeaderboard = ({ provider }) => {

  const [loading, setLoading] = useState();
  const [rows, setRows] = useState();
  const [selectedData, setSelectedData] = useState();
  const [showXPHistoryModal, setShowXPHistoryModal] = useState(false);

  useEffect( ()=>{
    const fetchRankSettings = async () => {
      setLoading(true);

      await fetch(PROD_API_URL + `/experience/fetchExperienceDatas`, {
        "method": "GET",
        "headers": {"content-type": "application/json", "accept": "*"},
      }).then(res=>res.json())
        .then((response)=>{
          console.log(response.data)
          setRows(response.data);

        });

      setLoading(false);
    }

    fetchRankSettings();
  },[]);

  const handleRowClick = (params) => {
    setSelectedData(params.row);
    console.log(params.row)
    setShowXPHistoryModal(true);
  }
  console.log(selectedData)

  return (
      <div className={styles.stakerContainer}>
        {loading && <LoadingSpinner local/>}
        <div className={styles.tableContainer}>
          {rows &&
              <DataGrid
                  rows={rows}
                  onRowClick={handleRowClick}
                  columns={RankingLeaderboardColums}
              />}
        </div>
        <ExperienceHistory selectedData={selectedData} showXPHistoryModal={showXPHistoryModal} setShowXPHistoryModal={setShowXPHistoryModal}  />}
      </div>
  )
}

export default RankingLeaderboard;